import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Link, useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const Quiz = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [quizData, setQuizData] = useState([])
    const navigate = useNavigate()

    useEffect(() => {
        getQuizData()
    }, [])

    const getQuizData = () => {
        ApiHelper.get(API_ENDPOINTS.QUIZ).then((res) => {
            if (res.status === 200) {
                setQuizData(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const imageBodyTemplate = (rowData) => {
        return (
            rowData?.thumbnail || rowData?.quizName ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/quiz/edit/${rowData.quizId}`)} >
                    <img
                        src={`${process.env.REACT_APP_BASE_URL}/${rowData?.thumbnail}`}
                        alt=""
                        style={{ width: 'auto', height: '50px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.src = "/img/placeholder-image.jpg"
                        }}
                    />
                    {rowData?.quizName}
                </div>
            ) : (
                <i className="pi pi-image"></i>
            )
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'} `}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <button onClick={() => navigate(`/quiz/edit/${rowData.quizId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
                <button onClick={() => confirmDeleteDailog(rowData.quizId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
            </>
        );
    };

    const enrolledBodyTemplate = (rowData) => {
        return (
            <>
                <div className='d-flex gap-1 align-items-center'>
                    <span className='badge text-bg-light m-0' style={{cursor: 'pointer', fontSize: '15px'}} onClick={() => navigate(`/quiz/${rowData?.quizId}/enrolled-users`)}>{rowData?.enrolled}</span>
                </div>
            </>
        );
    };
    
    const scoreBodyTemplate = (rowData) => {
        return (
            <>
                <div className='d-flex gap-1 align-items-center'>
                    <span onClick={() => navigate(`/quiz/${rowData.quizId}/scores/`)} className='badge text-bg-light m-1 cursor-pointer'>
                        <span className='me-1' style={{fontSize: '15px'}}>{rowData.scoreCount}</span>
                        <i className="pi pi-plus" style={{fontSize: '13px'}}></i>
                    </span>
                </div>
            </>
        );
    };
    
    const attemptsBodyTemplate = (rowData) => {
        return (
            <>
                <div className='d-flex gap-1 align-items-center'>
                    <span onClick={() => navigate(`/quiz/${rowData.quizId}/attempts`)} className='badge text-bg-light m-1 cursor-pointer'>
                        <span className='me-1' style={{fontSize: '15px'}}>{rowData.attemptCount}</span>
                    </span>
                </div>
            </>
        );
    };

    const sectionBodyTemplate = (rowData) => {
        return (
            <>
                <div className='d-flex gap-1 align-items-center'>
                    <span onClick={() => navigate(`/quiz/${rowData.quizId}/section/`)} className='badge text-bg-light m-1 cursor-pointer'>
                        <span className='me-1' style={{fontSize: '15px'}}>{rowData.sectionCount}</span>
                        <i className="pi pi-plus" style={{fontSize: '13px'}}></i>
                    </span>
                </div>
            </>
        );
    };

    const confirmDeleteDailog = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteQuiz(id),
        });
    };

    const deleteQuiz = (id) => {
        ApiHelper.delete(`${API_ENDPOINTS.QUIZ}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getQuizData()
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3 mb-2"><span class="text-muted fw-light"> <p className="breadcrumb-item active mb-0" aria-current="page"> Quiz </p> </span></h4>
                            <Link class="btn btn-primary" to={'/quiz/add'} >Add New Quiz</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={quizData} tableStyle={{ minWidth: '50rem' }} >
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            <Column sortable header='Name' body={imageBodyTemplate} field='quizName' /> 
                                            <Column sortable header='Subtitle' field='subtitle' />
                                            <Column sortable header='Sections' body={sectionBodyTemplate} field='sectionCount' />
                                            <Column sortable header='Enrolled' body={enrolledBodyTemplate} />
                                            <Column sortable header='Results' body={scoreBodyTemplate} />
                                            <Column sortable header='Attempts' body={attemptsBodyTemplate} />
                                            <Column sortable header='Status' body={statusBodyTemplate} />
                                            <Column sortable header='Action' body={actionBodyTemplate} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Quiz
